module.exports = __webpack_public_path__ + "static/media/hero-big.535f0969.webp";